import * as http from '../../modules/http';
export const SALES_ITEM_REQUEST_START = 'SALES_ITEM_REQUEST_START';
export const SALES_ITEM_REQUEST_SUCCESS = 'SALES_ITEM_REQUEST_SUCCESS';
export const SALES_ITEM_REQUEST_FAILED = 'SALES_ITEM_REQUEST_FAILED';
export const SALES_ITEM_REQUEST_NO_PERMISSION = 'SALES_ITEM_REQUEST_NO_PERMISSION';
export const SALES_ITEM_LINES_CHANGED = 'SALES_ITEM_LINES_CHANGED';

export function sales_item_request_start() {
    return {
        type: SALES_ITEM_REQUEST_START
    };
}

export function sales_item_request_success(data) {
    return {
        type: SALES_ITEM_REQUEST_SUCCESS,
        data:data
    };
}

export function sales_item_request_failed() {
    return {
        type: SALES_ITEM_REQUEST_FAILED
    };
}

export function sales_item_request_no_permission() {
    return {
        type: SALES_ITEM_REQUEST_NO_PERMISSION
    };
}

export function fetchSalesItemDataIfNeeded(id) {

    return (dispatch, getState) => {
        if (shouldFetchSalesItemData(id)) {
            return dispatch(fetchSalesItemData(id));
        }
    };
}

function shouldFetchSalesItemData(id) {
    return true;

    if (!id.salesItem.data){
        return true;
    }
    else{
        return false;
    }
}


function fetchSalesItemData(id) {
    return ((dispatch) => {
        dispatch(sales_item_request_start());
        let request = 'provider/deals';

        return http.postToServer(request,
            {
                id: "" + id
            },
            (response) =>  {
                dispatch(sales_item_request_success(response.data));
                return response.data;
            },
            (response) =>  {dispatch(sales_item_request_failed())},
            (response) =>  {dispatch(sales_item_request_no_permission())}

        );
    });
}